<template>
    <BaseModal modal-id="modalAlert" :sessionModal="true" :show-modal="showSessionModalInactive" :allow-esc="bindEscKey">
      <template #heading>{{ modalDetails.header }} 
      </template>
      <template #content>
        <div class="app-modal-basic">
          <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
          <div class="message-ext">
            <p>Your session will expire in<span class="timeRemaining"> {{ timeRemaining }} </span>seconds.</p>
            <p>{{ modalDetails.descriptionText }}</p>
          </div>
        </div>
      </template>
      <template #footing>
        <BaseButtonGroup>
          <template #default>
            <button @click.prevent="handleLogoutButton()">
              {{ modalDetails.logoutButtonText }}
            </button>
            <button class="app-btn-primary" @click.prevent="handleContinueSessionButton()">
              {{ modalDetails.continueSessionButtonText }}
            </button>
          </template>
        </BaseButtonGroup>
      </template>
    </BaseModal>
</template>


<script>
  import { mapGetters, mapActions } from 'vuex';
  import BaseModal from '@/components/ui/BaseModal'
  import BaseButtonGroup from '@/components/ui/BaseButtonGroup'
  import * as COMMONS from '../../store/_commons'

  export default {
    name: 'ModalExtendedLogin',
    components: {
      BaseModal,
      BaseButtonGroup,
    },
    props: {
        showSessionModalInactive: Boolean
    },
    data() {
      return {
        bindEscKey: false,
        modalDetails: {
          header: 'You are inactive for 15 minutes',
          descriptionText: "Please click on 'Continue session' or click 'Log Out' to end your session immediately.",
          continueSessionButtonText: 'Continue session',
          logoutButtonText: 'Log Out',
          modalType: 'expired'
        },
        timeRemaining: 60,
        timerId: 0,
      };
    },
    computed: {
      ...mapGetters({
        statusInfo: COMMONS.GUEST_LOGIN_STATUS_INFO,
      }),
    },
    mounted() {
        // window.addEventListener('DOMContentLoaded', () => {
        //     function afterInterval(callback, delay = 5000) {
        //     // set the initial timer
        //     let timer = setTimeout(callback, delay)

        //     const handler = () => {
        //         // cancel the previous timer
        //         clearTimeout(timer)
        //         // set a new one going
        //         timer = setTimeout(callback, delay)
        //     }

        //     // mousemove or click will cancel timer and trigger a new one
        //     window.addEventListener('mousemove', handler)
        //     window.addEventListener('click', handler)
        //     }

        //     afterInterval(() => alert('Do you want to continue?'))
        // })
    },
    methods: {
      ...mapActions({
        getGuestLogout: COMMONS.GUEST_LOGIN_GET_LOGOUT,
        // continueSession: COMMONS.GUEST_LOGIN_EXTEND_LOGIN
      }),
      handleContinueSessionButton() {
        clearTimeout(this.timerId);
        // this.continueSession();
        this.$emit('getShowInactiveStatus', false);
        this.timeRemaining = 60;
      },
      handleLogoutButton() {
        this.getGuestLogout();
        this.$emit('getShowInactiveStatus', false);
      },
      startTimer() {
        let vm = this;
        vm.timerId = setTimeout(function () {
          vm.updateTimer();
        }, 1000);
      },
      async updateTimer() {
        if(this.showSessionModalInactive) {
          if (this.timeRemaining > 0) {
          this.timeRemaining -=1;
          this.timeRemaining = this.timeRemaining < 10 ? "0" + this.timeRemaining : this.timeRemaining;
          this.startTimer();  
        }
          else {
            this.timeRemaining = 0.0;
          }
        } 
      }
    },

    beforeDestroy() {
      clearTimeout(this.timerId);
    }
  }
</script>
  
<style lang="scss" scoped>
// TODO: should have been picked up from @ridmv/web-themes but it's not...
.app-modal-basic {
  display: flex;
  align-items: flex-start;
  img {
    margin: 0.7em 0.5em 0 0;
    width: 1.25rem;
  }

  .message-ext {
  p {
    color: black;
  }}
  .timeRemaining {
    display: inline-block;
    width: 30px;
    text-align: center;
    @extend %font-sans-bold;
    font-size: 1.25rem;
  }
}
</style>